import { View } from "../../../../api/api";
import { types } from "./Menu.actions";
import { MenuTabs } from "./MenuTabs";
import { types as v2Types } from "../../../../v2/redux/types";
import { has } from "lodash";

export interface IMenuStateProps {
  selectedTab: MenuTabs;
  gameHistoryEnabled: boolean;
  gameHistoryAvailable: boolean;
  gameRulesAvailable: boolean;
  gameRulesContent: null;
}

const defaultState: IMenuStateProps = {
  selectedTab: MenuTabs.SETTINGS,
  gameHistoryEnabled: false,
  gameHistoryAvailable: false,
  gameRulesAvailable: false,
  gameRulesContent: null
};

export const menu = (state = defaultState, action) => {
  switch (action.type) {
    case v2Types.SET_STATE: {
      if (has(action.value, "view")) {
        let selectedTab = null;

        switch (action.value.view) {
          case View.GAME_RULES:
            selectedTab = MenuTabs.RULES;
            break;
          case View.GAME_HISTORY:
            selectedTab = MenuTabs.HISTORY;
            break;
          case View.MAIN_SETTINGS:
            selectedTab = MenuTabs.SETTINGS;
            break;
          case View.PAYTABLE:
            selectedTab = MenuTabs.PAYTABLE;
            break;
          default:
            selectedTab = null;
            break;
        }

        return selectedTab ? { ...state, selectedTab } : state;
      }

      return state;
    }

    case types.SET_GAME_HISTORY_ENABLED:
      return {
        ...state,
        gameHistoryEnabled: action.value
      };
    case types.SET_GAME_HISTORY_AVAILABLE:
      return {
        ...state,
        gameHistoryAvailable: action.value
      };
    case types.SET_GAME_RULES_AVAILABLE:
      return {
        ...state,
        gameRulesAvailable: action.value
      };
    case types.SET_GAME_RULES_CONTENT:
      return {
        ...state,
        gameRulesContent: action.value
      };
    default:
      return state;
  }
};
